export const API_BASE_URL = 'https://aisubhelper.emailpkh3693.workers.dev'; // Use production URL (Removed trailing slash)
export const CLERK_PUBLISHABLE_KEY = 'pk_test_dW5pcXVlLXNlcGlhLTgwLmNsZXJrLmFjY291bnRzLmRldiQ'; // Replace with your actual Clerk Publishable Key
